import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { translate } from 'react-switch-lang';
import {
  TabPane, TabContent, NavLink, NavItem, Nav, Col, Row,
} from 'reactstrap';
import {
  Contact, Homes, Inbox, Profile, Settings,
} from '../../../../../theme/theme/src/constant';
import PageCard from '../../containers/PageCard';
import Breadcrumb from '../../components/Breadcrumb';
import Tabs from '../../components/tabs/Tabs';
import ViberSettings from './Parts/ViberSettings';
import TelegramSettings from './Parts/TelegramSettings';
import WebChatSettings from './Parts/WebChatSettings';
import SmsSettings from './Parts/SmsSettings';
import InternalChatSettings from './Parts/InternalChatSettings';
import SystemSettings from './Parts/SystemSettings';
import TextsSettings from './Parts/TextsSettings';

function SettingsPage({ t }) {
  const [LeftLineTab, setLeftLineTab] = useState('1');
  return (
    <div>
      <Breadcrumb title={t('Settings')} parent={t('Home')} />
      <PageCard title={t('Settings')}>
        <Tabs headers={[
          { content: t('settings.tabSettings') },
          { content: t('Texts') },
          // { content: 'Viber' },
          // { content: 'Telegram' },
          // { content: 'Web' },
          // { content: 'Sms' },
          // { content: t('settings.Internal') },
        ]}
        >
          <SystemSettings />
          <TextsSettings />
          <ViberSettings />
          <TelegramSettings />
          <WebChatSettings />
          <SmsSettings />
          <InternalChatSettings />
        </Tabs>
      </PageCard>
    </div>
  );
}

SettingsPage.propTypes = {
  t: PropTypes.func.isRequired,
};

export default translate(SettingsPage);
